import { RootState } from '@/App/store';

export const selectAppInfo = (state: RootState) => state.info;
